import ChosenThemeSizeActionContext from '@/contexts/styles/ChosenThemeSizeActionContext';
import ChosenThemeSizeContext from '@/contexts/styles/ChosenThemeSizeContext';
import ThemeSize from '@/types/styles/ThemeSize';
import { Box, Button } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useLocalStorage } from 'react-use';


export interface IChosenThemeSizeProviderProps {
    override?: ThemeSize
}

export const ChosenThemeSizeProvider: FC<PropsWithChildren<IChosenThemeSizeProviderProps>> = ({ override, children }) => {
    const [theme, setTheme] = useLocalStorage<ThemeSize>('theme-size', 'medium')

    //const [theme, setTheme] = useState<ThemeName>('dark');

    const data = (
        <ChosenThemeSizeContext.Provider value={override ?? theme}>
            {children}
        </ChosenThemeSizeContext.Provider>
    )

    if (override) {
        return data;
    }

    return (
        <ChosenThemeSizeActionContext.Provider value={setTheme}>
            {data}
            {/* <Box sx={{height: 64}}></Box>
            <Box sx={{ background: 'white', position: 'fixed', bottom: 0, left: 0, right: 0, textAlign: 'center', height: 64}}>
                <Box sx={{ margin: 'auto', textAlign: 'center'}}>
                    {theme}
                </Box>
                <Button onClick={() => setTheme('extra-small')}>
                    Extra Small
                </Button>
                <Button onClick={() => setTheme('small')}>
                    Small
                </Button>
                <Button onClick={() => setTheme('medium')}>
                    Medium
                </Button>
                <Button onClick={() => setTheme('large')}>
                    Large
                </Button>
                <Button onClick={() => setTheme('extra-large')}>
                    Extra large
                </Button>
            </Box> */}
        </ChosenThemeSizeActionContext.Provider>
    );
}

export default ChosenThemeSizeProvider;
